export default __webpack_public_path__ + "static/media/license-bg.833952c5.webp";